// filepath: apps/web/src/features/admin/templates/update/TemplateUpdatesRoute.tsx
//
// FR-UI-ADM-12 AC-1 — route shell for the template-updates list
// at /admin/templates/updates.
//
// The route reads the resolved tenant slug + environmentKind from
// the auth/tenant chain and delegates to TemplateUpdatesPage.
// The list view is read-only and accessible from both
// environments; only the apply verb (POST /api/templates/{id}/
// apply-update) is staging-only.

import React from "react";
import { TemplateUpdatesPage } from "./TemplateUpdatesPage";
import type { TemplateUpdateRow } from "./types";

interface TemplateUpdatesRouteProps {
  /** Resolved environment kind from /api/tenant-config. */
  environmentKind: string;
  /** View-row click handler — wires to /admin/templates/updates/:templateId. */
  onView?: (row: TemplateUpdateRow) => void;
}

export function TemplateUpdatesRoute({
  environmentKind: _environmentKind,
  onView,
}: TemplateUpdatesRouteProps): React.ReactElement {
  return <TemplateUpdatesPage onView={onView} />;
}
